import React from 'react';
import GlobalSettingSidebar from './GlobalSetting';
import LayerListSidebar from './LayerList';
import LayerOptionSidebar from './LayerOption';
import GoogleSearch from './GoogleSearch';
import IoTSensorThings from './IoTSensorThings' ;
import Surveying from './Surveying';
import Analysis from './Analysis';

class StatusBar extends React.Component{
    constructor(){
        super();
        this.state = {
            camera : {
                x:0.00,
                y:0.00,
                z:0.00
            },
            FPSintervalId:{},
            TerrainintervalId:{},
            MouseintervalId:{},
            fps:0.0,
            terrainNod:0.00
        };
        this.cameraPOS = this.cameraPOS.bind(this);
        this.FPS = this.FPS.bind(this);
        this.getTerrainNod = this.getTerrainNod.bind(this);
    }
    componentDidMount(){
        var MouseintervalId = requestAnimationFrame(this.cameraPOS);
        var FPSintervalId = requestAnimationFrame(this.FPS);
        var TerrainintervalId = requestAnimationFrame(this.getTerrainNod);
        this.setState({FPSintervalId: FPSintervalId,TerrainintervalId:TerrainintervalId,MouseintervalId: MouseintervalId});
    }
    componentWillUnmount(){
        cancelAnimationFrame(this.state.MouseintervalId);
        cancelAnimationFrame(this.state.FPSintervalId);
        cancelAnimationFrame(this.state.TerrainintervalId);
    }
    cameraPOS(){
        var camera = window.main.OView.camera.pos;
        if(camera!==null)
            this.setState({camera:camera});
        requestAnimationFrame(this.cameraPOS);
    }
    FPS(){
        if(window.main !== null){
            var fps = (window.main.OView.getFPS()).toFixed(1);
            this.setState({fps:fps});
            requestAnimationFrame(this.FPS);
        }            
    }
    getTerrainNod(){
        if(window.main !== null){
            var terrainNod = (window.main.OView.getTerrainNodeProgress()).toFixed(2);
            this.setState({terrainNod:terrainNod});
            requestAnimationFrame(this.getTerrainNod);
        }
    }
    render(){
        const x = this.state.camera.x;
        const y = this.state.camera.y;
        const z = this.state.camera.z>=1000 ? (this.state.camera.z/1000).toFixed(2) + " 公里" : (this.state.camera.z).toFixed(2)+" 公尺";
        const fps = this.state.fps;
        const terrainNod = this.state.terrainNod * 100;
        return(
            <div id="statusBar">
                <div id="mousePos">
                    PilotGaea_v.12　　
                    {
                        terrainNod === 100 ?
                        <i className="circle thin icon"></i>
                        :
                        <i className="spinner loading icon"></i>
                    }
                    {terrainNod + "%"}　　FPS：{fps}　　相機高度：{z}　　相機經度：{x.toFixed(6)}　　相機緯度：{y.toFixed(6)}
                </div>
            </div>
        );
    }

}

class ToolBar extends React.Component{
    constructor() {
        super();
        this.state = {
            isSideMenu:[{
                globalSetting:false,
                layerList:false,
                layerOption:false,
                googleSearch:false,
                IoTSensorThings:false                
            }],
            isCard:[{
                surveying:false,
                analysis:false
            }],
            layerList : {
                Layer_2D:[],
                Layer_3D:[]
            },
            deleteList : {},
            LayerLength:0
        };
        this.setglobalSettingOpen = this.setglobalSettingOpen.bind(this);
        this.setlayerListOpen = this.setlayerListOpen.bind(this);
        this.setlayerOptionOpen = this.setlayerOptionOpen.bind(this); 
        this.setgoogleSearchOpen = this.setgoogleSearchOpen.bind(this); 
        this.setIoTSensorThingsOpen = this.setIoTSensorThingsOpen.bind(this);
        this.setSurveyingOpen = this.setSurveyingOpen.bind(this); 
        this.setAnalysisOpen = this.setAnalysisOpen.bind(this);      
        this.setOpenLayer = this.setOpenLayer.bind(this);
        this.deleteLayer = this.deleteLayer.bind(this);    
    }    
    setglobalSettingOpen(){
        const layerListOpen = [{
            globalSetting:!this.state.isSideMenu[0].globalSetting,
            layerList:false,
            layerOption:false,
            googleSearch:false,
            IoTSensorThings:false  
        }];
        this.setState({isSideMenu:layerListOpen});
    }
    setlayerListOpen(){
        const layerListOpen = [{
            globalSetting:false,
            layerList:!this.state.isSideMenu[0].layerList,
            layerOption:false,
            googleSearch:false,
            IoTSensorThings:false
        }];
        this.setState({isSideMenu:layerListOpen});
    }
    setlayerOptionOpen(){
        const layerListOpen = [{
            globalSetting:false,
            layerList:false,
            layerOption:!this.state.isSideMenu[0].layerOption,
            googleSearch:false,
            IoTSensorThings:false
        }];
        this.setState({isSideMenu:layerListOpen});
    }
    setgoogleSearchOpen(){
        const layerListOpen = [{
            globalSetting:false,
            layerList:false,
            layerOption:false,
            googleSearch:!this.state.isSideMenu[0].googleSearch,
            IoTSensorThings:false
        }];
        this.setState({isSideMenu:layerListOpen});
    } 
    setIoTSensorThingsOpen(){
        const layerListOpen = [{
            globalSetting:false,
            layerList:false,
            layerOption:false,
            googleSearch:false,
            IoTSensorThings:!this.state.isSideMenu[0].IoTSensorThings
        }];
        this.setState({isSideMenu:layerListOpen});
    }   
    setSurveyingOpen(){
        const CardOpen = [{
            surveying:!this.state.isCard[0].surveying,
            analysis:false
        }];
        this.setState({isCard:CardOpen});
    }
    setAnalysisOpen(){
        const CardOpen = [{
            surveying:false,
            analysis:!this.state.isCard[0].analysis
        }];
        this.setState({isCard:CardOpen});
    }
    setOpenLayer(layer,layerHandel){
        let openLayer = this.state.layerList;
        if(layer.TYPE === "Overlay"){
            openLayer.Layer_2D.push({
                layerName : layer.TITLE,
                layerType : layer.TYPE
            });
        }
        else{
            openLayer.Layer_3D.push({
                layerName : layer.TITLE,
                layerType : layer.TYPE,
                layerMode : layer.MODE,
                layerClass : layer.CLASS,
                layerLocation : layer.LOCATION,
                layerHandel : layerHandel,
                isBIMModel : layer.ISBIM,
                BIMAttrsList : layer.BIMATTRS,
                VideoPath : layer.VideoPath,
                VideoPOS : layer.VideoPOS,
                VideoV : layer.VideoV,
                VideoUP : layer.VideoUP,
                HFov : layer.HFov,
                VFov : layer.VFov,
                Far : layer.Far,
                Near : layer.Near,
                ImgW : layer.ImgW,
                ImgH : layer.ImgH,
                URL : layer.URL
            });
        }
        let LayerLength = openLayer.Layer_2D.length+openLayer.Layer_3D.length;
        this.setState({layerList:openLayer,deleteList:{},LayerLength:LayerLength});
    }
    deleteLayer(layer){
        let deleteLayerList = this.state.layerList;
        let DeleteList = {
            layerName : layer.TITLE,
            layerType : layer.TYPE
        };
        if(layer.TYPE === "Overlay"){
            for (let i = 0, len = deleteLayerList.Layer_2D.length; i < len; i++){
                if (deleteLayerList.Layer_2D[i].layerName === layer.TITLE){
                    deleteLayerList.Layer_2D.splice(i, 1);
                    let LayerLength = deleteLayerList.Layer_2D.length+deleteLayerList.Layer_3D.length;
                    this.setState({layerList:deleteLayerList,deleteList:DeleteList,LayerLength:LayerLength});
                    return ;
                }
            }
        }
        else{
            for (let i = 0, len = deleteLayerList.Layer_3D.length; i < len; i++){
                if (deleteLayerList.Layer_3D[i].layerName === layer.TITLE){
                    deleteLayerList.Layer_3D.splice(i, 1);
                    let LayerLength = deleteLayerList.Layer_2D.length + deleteLayerList.Layer_3D.length;
                    this.setState({layerList:deleteLayerList,deleteList:DeleteList,LayerLength:LayerLength});
                    return ;
                }
            }
        }
        
    }
    render(){
        const globalSetting = this.state.isSideMenu[0].globalSetting;
        const layerListOpen = this.state.isSideMenu[0].layerList;
        const layerOptionOpen = this.state.isSideMenu[0].layerOption;
        const googleSearchOpen = this.state.isSideMenu[0].googleSearch;
        const IoTSensorThingsOpen = this.state.isSideMenu[0].IoTSensorThings;        
        const surveying = this.state.isCard[0].surveying;
        const analysis = this.state.isCard[0].analysis;
        const LayerLength = this.state.LayerLength;
        const Layer_2D_Length = (this.state.layerList.Layer_2D).length;

        return(
            <div>
                <div className="ts labeled icon left fixed inverted vertical menu">
                    <a className="item" onClick={(e)=>this.setglobalSettingOpen()}>
                        <i className="content icon"></i>
                    </a>
                    <a className="item" onClick={(e)=>this.setlayerListOpen()}>
                        <i className="folder outline icon"></i> 圖層集
                    </a>
                    <a className="item" onClick={(e)=>this.setlayerOptionOpen()}>
                        <i className="inverted sliders icon"></i> 圖層設定
                        {
                            LayerLength === 0 ? null:
                            <div id="tag" class="ts floating circular positive label" style={{top: '1px'}}>{LayerLength}</div>
                        }
                        
                    </a>
                    <a className="item" onClick={(e)=>this.setgoogleSearchOpen()}>
                        <i className="inverted search icon"></i> 搜尋
                    </a>
                    <a className="item" onClick={(e)=>this.setIoTSensorThingsOpen()}>
                        <i className="inverted wifi icon"></i> CIoT
                    </a>
                    <a className="item" onClick={(e)=>this.setSurveyingOpen()}>
                        <i className="inverted crop icon"></i> 測量
                    </a>
                    <a className="item" onClick={(e)=>this.setAnalysisOpen()}>
                        <i className="inverted bar chart icon"></i> 分析
                    </a>
                </div>
                <GlobalSettingSidebar 
                    isglobalSettingOpen={globalSetting} 
                    setglobalSettingOpen={this.setglobalSettingOpen.bind(this)}
                />
                <LayerListSidebar 
                    islayerListOpen={layerListOpen} 
                    setlayerListOpen={this.setlayerListOpen.bind(this)} 
                    setOpenLayer = {(layer,layerHandel)=>this.setOpenLayer(layer,layerHandel)} 
                    deleteLayer = {(layer)=>this.deleteLayer(layer)}
                    deleteList = {this.state.deleteList}
                    LayerLength = {Layer_2D_Length}
                />
                <LayerOptionSidebar 
                    islayerOptionOpen={layerOptionOpen} 
                    setlayerOptionOpen={this.setlayerOptionOpen.bind(this)}
                    deleteLayerList={(layer)=>this.deleteLayer(layer)}
                    LayerList = {this.state.layerList}
                />
                <GoogleSearch 
                    isgoogleSearchOpen = {googleSearchOpen} 
                    setgoogleSearchOpen = {this.setgoogleSearchOpen.bind(this)}
                />
                <IoTSensorThings 
                    isIoTSensorThingsOpen = {IoTSensorThingsOpen} 
                    setIoTSensorThingsOpen = {this.setIoTSensorThingsOpen.bind(this)}
                />
                {
                    surveying?
                        <Surveying 
                            setSurveyingOpen = {this.setSurveyingOpen.bind(this)}
                        />
                        :
                        null
                }
                {
                    analysis?
                        <Analysis 
                            setAnalysisOpen = {this.setAnalysisOpen.bind(this)}
                        />
                        :
                        null
                }                
                <StatusBar />

            </div>            
        );
    }
}

export default ToolBar;
